// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2wdJt","list":"PatternAutocomplete_list__YWAdu"};